"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const one_1 = require("remax/one");
const classnames_1 = __importDefault(require("classnames"));
const common_1 = require("../common");
const prefixCls = common_1.getPrefixCls('card');
const Card = (props) => {
    const { title, description, extra, cover, foot, direction = 'vertical', shadow, style, contentStyle, children, onTap, } = props;
    const renderTitle = (isHead) => {
        return title || description || extra ? (React.createElement(one_1.View, { className: classnames_1.default(`${prefixCls}-head`, { [`${prefixCls}-content-head`]: !isHead }) },
            React.createElement(one_1.View, null,
                title ? React.createElement(one_1.View, { className: `${prefixCls}-title` }, title) : null,
                description ? React.createElement(one_1.View, { className: `${prefixCls}-description` }, description) : null),
            React.createElement(one_1.View, { className: `${prefixCls}-extra` }, extra))) : null;
    };
    const renderHead = () => {
        if (cover) {
            return React.createElement(one_1.View, { className: `${prefixCls}-cover` }, cover);
        }
        return renderTitle(true);
    };
    const renderFoot = () => {
        return foot ? (React.createElement(one_1.View, { className: classnames_1.default(`${prefixCls}-foot`, {
                [`${prefixCls}-foot-horizontal`]: direction === 'horizontal',
            }) }, foot)) : null;
    };
    return (React.createElement(one_1.View, { className: classnames_1.default(prefixCls, {
            [`${prefixCls}-horizontal`]: cover && direction === 'horizontal',
            [`${prefixCls}-shadow`]: shadow,
        }), style: style, onTap: onTap },
        renderHead(),
        React.createElement(one_1.View, { className: `${prefixCls}-content`, style: Object.assign({}, contentStyle) },
            cover ? renderTitle(false) : null,
            children,
            direction === 'horizontal' ? renderFoot() : null),
        direction !== 'horizontal' ? renderFoot() : null));
};
exports.default = Card;
